import {
    GET_AFFILIATES_REQUEST, GET_AFFILIATES_REQUEST_SUCCESS, GET_AFFILIATES_REQUEST_FAILURE, COUNT_AFFILIATES,
} from '../constants/get_affiliates.constants';

export const getAffiliatesRequest = (where, pagination) => ({
    type: GET_AFFILIATES_REQUEST, where, pagination,
});

export const getAffiliatesRequestSuccess = payload => ({
    type: GET_AFFILIATES_REQUEST_SUCCESS, payload,
});

export const getAffiliatesRequestFailure = error => ({
    type: GET_AFFILIATES_REQUEST_FAILURE, error,
});

export const countAffiliatesSuccess = payload => ({
    type: COUNT_AFFILIATES, payload,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/redux/actions/get_affiliates.actions.js